import "./src/styles/globals.css";

export const shouldUpdateScroll = ({ routerProps }) => {
  const { disableScrollUpdate } = routerProps.location.state
    ? routerProps.location.state
    : { disableScrollUpdate: false };
  return !disableScrollUpdate;
};
